import React from 'react'
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../general/general-component/abstruct-component/AbstructLang';

function CartInSlider({datum,handleIncrement,handleDecrement,handleAddToCart}) {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang();
    return (
        <div className='one_sildd' dir={langLocal === 'ar'? "rtl": "ltr"}>
            <div className='qty'>{datum.qty}</div>
            <img src={datum.url} alt={datum.name} />
            <div className='cart_info'>
                <span>{datum.name}</span>
                <p className='description'>{datum.description}</p>
                <div className='div_supplier'><strong>{translate('supplier')}: {' '}</strong><p className='supplier'>{datum.supplier}</p></div>
                <div className='div_add_qty'>
                    <div className='add_qty'>
                        <i className='fa fa-plus' onClick={() => handleIncrement(datum.id)}></i>
                        <p>{datum.newQty}</p>
                        <i className='fa fa-minus' onClick={() => handleDecrement(datum.id)}></i>
                    </div>
                </div>
            </div>
            <div className='add_to_cart' onClick={() => handleAddToCart(datum)} >
                <span>{translate('add_to_cart')}</span>
            </div>
        </div>
    )
}

export default CartInSlider